import * as React from 'react'
import * as _ from 'lodash'

import { NetworkUser } from 'golgi'
import { standardSCU } from '../util'
import StepProps from './StepProps'
import * as Model from '../types/document'
import { Cursor } from 'src/lib/Cursor';
import { NewDrag } from 'src/view/drags';
import { DragSourceSpec, DragSourceConnector, DragSourceMonitor, DragSource } from 'react-dnd';


interface DragNewProps {
  children: React.ReactElement<any>,
  drag: NewDrag,
}


const dragSpec: DragSourceSpec<DragNewProps, NewDrag> = {
  beginDrag(props) {
    return props.drag
  },
};

function dragCollect(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  }
}

class DragNew extends React.Component<DragNewProps & ReturnType<typeof dragCollect>> {
  render() {
    return this.props.connectDragSource(this.props.children)
  }
}

export default DragSource("new", dragSpec, dragCollect, {arePropsEqual: () => false})(DragNew)



// WEBPACK FOOTER //
// ./src/view/DragNew.tsx